import React from "react";
import { Instagram, Mail, ArrowUp } from "lucide-react";
import { PROFILE, NAV_LINKS } from "@/lib/portfolioData";

export default function Footer() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="relative border-t border-white/5 bg-[#0A0A0A] pt-16 pb-8 px-6 md:px-10" data-testid="site-footer">
      {/* Big signature */}
      <div className="max-w-[1400px] mx-auto overflow-hidden mb-12">
        <p
          className="font-display font-bold uppercase text-transparent leading-none tracking-tighter select-none"
          style={{
            WebkitTextStroke: "1px rgba(212,175,55,0.35)",
            fontSize: "clamp(3.5rem, 14vw, 12rem)",
          }}
        >
          Tariq Kamal
        </p>
      </div>

      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 pb-12">
        <div className="md:col-span-5">
          <p className="font-display uppercase text-sm tracking-[0.3em] text-[#D4AF37] mb-4">
            Cinematic Content Creator
          </p>
          <p className="text-[#B3B3B3] text-sm leading-relaxed max-w-md">
            Available for global collaborations with lifestyle brands, tourism boards, and
            innovative companies who value cinematic craft.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/50 font-display mb-4">
            Navigation
          </p>
          <ul className="space-y-2">
            {NAV_LINKS.slice(0, 6).map((l) => (
              <li key={l.id}>
                <button
                  onClick={() => document.getElementById(l.id)?.scrollIntoView({ behavior: "smooth" })}
                  className="text-white/75 hover:text-[#D4AF37] transition-colors text-sm font-display"
                  data-testid={`footer-nav-${l.id}`}
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/50 font-display mb-4">
            Connect
          </p>
          <div className="flex flex-col gap-3">
            <a
              href={`mailto:${PROFILE.email}`}
              className="text-white/75 hover:text-[#D4AF37] transition-colors text-sm flex items-center gap-2"
              data-testid="footer-email"
            >
              <Mail className="w-3.5 h-3.5" />
              {PROFILE.email}
            </a>
            <a
              href={PROFILE.instagramUrl}
              target="_blank"
              rel="noreferrer"
              className="text-white/75 hover:text-[#D4AF37] transition-colors text-sm flex items-center gap-2"
              data-testid="footer-instagram"
            >
              <Instagram className="w-3.5 h-3.5" />
              @{PROFILE.instagram}
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row items-center justify-between gap-4 pt-8 border-t border-white/5">
        <p className="text-xs text-white/40 font-display tracking-wider">
          © 2026 Tariq Kamal. All Rights Reserved.
        </p>
        <div className="flex items-center gap-4">
          <span className="text-[10px] uppercase tracking-[0.3em] text-white/40 font-display">
            Krishnanagar · Nepal
          </span>
          <button
            onClick={scrollTop}
            className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-[#D4AF37] hover:border-[#D4AF37]/40 transition-all"
            data-testid="footer-scroll-top"
            aria-label="Back to top"
          >
            <ArrowUp className="w-4 h-4" />
          </button>
        </div>
      </div>
    </footer>
  );
}
